module.exports = __webpack_public_path__ + "static/img/Nov-23-15_Schneider_LA_491_web.b838a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Nov-23-15_Schneider_LA_491_web.jpg
// module id = I3we
// module chunks = 0